import './HomePage.css';

export default function Home() {
    return (
        <div className="home-body">
            <div id="intro-container">
                <h1 id="intro-text">Welcome to my personal website! Here, you can learn more about
                    me.
                </h1>
            </div>
        </div>
    );
}